import { useNavigate } from 'react-router';

import { confirmPersonalDetails } from '@/api/user';

import { useCheckPersonalDetails } from '@/components/PageForm/PersonalDetails/Review/hooks/useCheckPersonalDetails';

import { ROUTE } from '@/constants/routes';

import { useMutationWithUserData } from '@/hooks/useMutationWithUserData';

export const useReviewPersonalDetails = () => {
  const navigate = useNavigate();
  const { user, isUserInfoComplete } = useCheckPersonalDetails();
  const { mutate, isPending, error, reset } = useMutationWithUserData({
    mutationFn: confirmPersonalDetails,
    onFinished: () => {
      navigate(ROUTE.MORE_INFORMATION, {
        replace: true,
        state: { notNavigateByStatus: true },
      });
    },
  });

  const onContinue = () => {
    reset();
    mutate();
  };

  const onUpdate = () => navigate(ROUTE.UPDATE_PERSONAL_DETAILS);

  return {
    user,
    isUserInfoComplete,
    isPending,
    error,
    onContinue,
    onUpdate,
  };
};
